import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { apiUrl } from "../../constants";

export const resetPassword = createAsyncThunk(
  "resetPassword/resetPassword",
  async (data, thunkAPI) => {
    const passResetData = {
      new_password: data.new_password,
      confirm_password: data.confirm_password,
    };

    const queryParams = new URLSearchParams();
    queryParams.append("token", data.token);

    const requestOptions = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(passResetData),
    };

    try {
      const response = await fetch(
        `${apiUrl}/reset_password?${queryParams.toString()}`,
        requestOptions
      );

      if (!response.ok) {
        let errorMessage = "Network response was not ok";
        try {
          const error = await response.json();
          errorMessage = error.msg || errorMessage;
        } catch (e) {
          errorMessage = await response.text();
        }
        throw new Error(errorMessage || "Unknown error occurred");
      }

      const result = await response.json();
      return result;
    } catch (error) {
      console.error("Password reset failed:", error);
      return thunkAPI.rejectWithValue(error.message);
    }
  }
);

const resetPasswordSlice = createSlice({
  name: "resetPassword",
  initialState: {
    status: "idle", // 'idle' | 'loading' | 'success' | 'error'
    error: null,
    resetPassword: null,
  },
  reducers: {
    resetPasswordState: (state) => {
      state.status = "idle";
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(resetPassword.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(resetPassword.fulfilled, (state, action) => {
        state.resetPassword = action.payload;
        state.status = "success";
        state.error = null;
      })
      .addCase(resetPassword.rejected, (state, action) => {
        state.status = "error";
        state.error = action.payload;
      });
  },
});

export const { resetPasswordState } = resetPasswordSlice.actions;
export default resetPasswordSlice.reducer;
